const addressHelpers = require('base/checkout/address');
const base = require('base/checkout/shipping');
const baseFormHelpers = require('base/checkout/formErrors');

/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(
  productLineItem,
  shipping,
  order,
  customer
) {
  const uuidEl = $(`input[value=${productLineItem.UUID}]`);
  const shippings = order.shipping;

  let form;
  let $shippingAddressSelector;
  let hasSelectedAddress = false;

  if (uuidEl && uuidEl.length > 0) {
    form = uuidEl[0].form;
    $shippingAddressSelector = $('.addressSelector', form);
  }

  if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
    $shippingAddressSelector.empty();
    // Add New Address option
    $shippingAddressSelector.append(
      addressHelpers.methods.optionValueForAddress(null, false, order)
    );
    // Separator -
    $shippingAddressSelector.append(
      addressHelpers.methods.optionValueForAddress(
        order.resources.shippingAddresses,
        false,
        order,
        { className: 'multi-shipping' }
      )
    );

    shippings.forEach((aShipping) => {
      if (
        !aShipping.selectedShippingMethod ||
        !aShipping.selectedShippingMethod.storePickupEnabled
      ) {
        const isSelected = shipping.UUID === aShipping.UUID;
        hasSelectedAddress = hasSelectedAddress || isSelected;

        const addressOption = addressHelpers.methods.optionValueForAddress(
          aShipping,
          isSelected,
          order,
          { className: 'multi-shipping' }
        );
        const newAddress =
          addressOption.html() === order.resources.addNewAddress;
        const matchingUUID = aShipping.UUID === shipping.UUID;
        if (
          (newAddress && matchingUUID) ||
          (!newAddress && matchingUUID) ||
          (!newAddress && !matchingUUID)
        ) {
          $shippingAddressSelector.append(addressOption);
        }
        if (newAddress && !matchingUUID) {
          $(addressOption[0]).remove();
        }
      }
    });
    if (customer.addresses && customer.addresses.length > 0) {
      $shippingAddressSelector.append(
        addressHelpers.methods.optionValueForAddress(
          order.resources.accountAddresses,
          false,
          order
        )
      );
      customer.addresses.forEach((address) => {
        const isSelected = shipping.matchingAddressId === address.ID;
        $shippingAddressSelector.append(
          addressHelpers.methods.optionValueForAddress(
            {
              UUID: `ab_${address.ID}`,
              shippingAddress: address,
            },
            isSelected,
            order
          )
        );
      });
    }
  }

  if (!hasSelectedAddress) {
    // show
    $(form).addClass('hide-details');
  } else {
    $(form).removeClass('hide-details');
  }
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
  // First copy over shipmentUUIDs from response, to each PLI form
  order.shipping.forEach((aShipping) => {
    aShipping.productLineItems.items.forEach((productLineItem) => {
      base.methods.updateProductLineItemShipmentUUIDs(
        productLineItem,
        aShipping
      );
    });
  });

  // Now update shipping information, based on those associations
  base.methods.updateShippingMethods(shipping);
  $('#shippingCountrydefault').trigger('change');
  base.methods.updateShippingAddressFormValues(shipping);
  base.methods.updateShippingSummaryInformation(shipping, order);

  // And update the PLI-based summary information as well
  shipping.productLineItems.items.forEach((productLineItem) => {
    updateShippingAddressSelector(productLineItem, shipping, order, customer);
    base.methods.updatePLIShippingSummaryInformation(
      productLineItem,
      shipping,
      order,
      options
    );
  });
}

/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
  const uuidEl = $(`input[value=${shipping.UUID}]`);
  if (uuidEl && uuidEl.length > 0) {
    $.each(uuidEl, (shipmentIndex, el) => {
      const { form } = el;
      if (!form) return;

      const $shippingMethodList = $('.shipping-method-list', form);

      if ($shippingMethodList && $shippingMethodList.length > 0) {
        $shippingMethodList.empty();
        const shippingMethods = shipping.applicableShippingMethods;
        const selected = shipping.selectedShippingMethod || {};
        const shippingMethodFormID = `${form.name}_shippingAddress_shippingMethodID`;
        //
        // Create the new rows for each shipping method
        //
        $.each(shippingMethods, (methodIndex, shippingMethod) => {
          const tmpl = $('#shipping-method-template').clone();
          // set input
          $('input', tmpl)
            .prop('id', `shippingMethod-${shippingMethod.ID}-${shipping.UUID}`)
            .prop('name', shippingMethodFormID)
            .prop('value', shippingMethod.ID)
            .attr('checked', shippingMethod.ID === selected.ID)
            .attr('data-pickup', shippingMethod.storePickupEnabled);

          $('label', tmpl).prop(
            'for',
            `shippingMethod-${shippingMethod.ID}-${shipping.UUID}`
          );
          // set shipping method name
          $('.display-name', tmpl).text(shippingMethod.displayName);
          // set or hide arrival time
          if (shippingMethod.estimatedArrivalTime) {
            $('.arrival-time', tmpl)
              .text(`(${shippingMethod.estimatedArrivalTime})`)
              .show();
          }
          // set shipping cost
          $('.shipping-cost', tmpl).text(shippingMethod.shippingCost);
          $shippingMethodList.append(tmpl.html());
        });
      }
    });
  }

  $('body').trigger('shipping:updateShippingMethods', { shipping });
}

base.saveMultiShipInfo = function () {
  $('.btn-save-multi-ship').on('click', function (e) {
    e.preventDefault();

    // Save address to checkoutAddressBook
    const form = $(this).closest('form');
    const $rootEl = $(this).closest('.shipping-content');
    const data = $(form).serialize();
    const url = $(form).attr('action');

    const checkedShippingMethod = $(
      'input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked',
      form
    );
    const isStorePickUpMethod = checkedShippingMethod.attr('data-pickup');
    const storeId = $("input[name='storeId']", form).val();
    const errorMsg =
      'Before you can continue to the next step, you must select a store.';

    if (isStorePickUpMethod === 'true' && storeId === undefined) {
      base.methods.createErrorNotification(errorMsg);
    } else {
      $rootEl.spinner().start();
      $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data,
      })
        .done((response) => {
          baseFormHelpers.clearPreviousErrors(form);
          if (response.error) {
            if (response.fieldErrors && response.fieldErrors.length) {
              response.fieldErrors.forEach((error) => {
                if (Object.keys(error).length) {
                  baseFormHelpers.loadFormErrors(form, error);
                }
              });
            } else if (response.serverErrors && response.serverErrors.length) {
              $.each(response.serverErrors, (index, element) => {
                base.methods.createErrorNotification(element);
              });
            }
          } else {
            // Update UI from response
            $('body').trigger('checkout:updateCheckoutView', {
              order: response.order,
              customer: response.customer,
            });

            base.methods.viewMultishipAddress($rootEl);
          }

          if (response.order && response.order.shippable) {
            $('button.submit-shipping').attr('disabled', null);
          }

          $rootEl.spinner().stop();
        })
        .fail((err) => {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }

          $rootEl.spinner().stop();
        });
    }
    return false;
  });
};

base.methods.updateShippingInformation = updateShippingInformation;
base.methods.updateShippingAddressSelector = updateShippingAddressSelector;
base.methods.updateShippingMethods = updateShippingMethods;

module.exports = base;
